// Max pasted-text length we convert into a prettified block. Above ~150KB the syntax-highlighting
// pass makes the highlighted browser view noticeably laggy, so 150KB balances how much we highlight
// against load time. Larger pastes fall through to a plain-text paste.
export const MAX_PRETTIFY_PASTE_SIZE = 150 * 1024

const CODE_PATTERNS = [
  /^\s*(?:(?:import|export)\b.*?\bfrom\s+['"`]|#include\s+[<"])/m, // module import
  /\w+(?:::\w+){2,}/, // double-colon path
  /^[ \t]{4,}[a-z][\w-]*:(?:[ \t]|$)/m, // deep YAML key
  /^\d{2,4}[-:]\d{2}[-:]\d{2}[T.,]/m, // timestamp / structured log
  /^(?:#{1,6} \S|[│╷╵])/m, // markdown heading / box-drawing
]

export function looksLikeCode(text: string): boolean {
  if ((text.match(/^(?:[ ]{2,}|\t)(?![-*•])\S/gm) ?? []).length >= 2) return true
  if (CODE_PATTERNS.some(re => re.test(text))) return true

  // ≥8% of non-whitespace chars are code punctuation. Balance between false positives and shorter code snippets (most expensive, last)
  const nonSpace = text.replace(/\s/g, '')
  return nonSpace.length >= 200 && (nonSpace.match(/[{}[\];=<>]/g)?.length ?? 0) / nonSpace.length >= 0.08
}
